var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"trav-stars"},_vm._l((_vm.stars),function(n){return _c('i',{key:n,staticClass:"icon-i16_star"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }